import { NON_EXISTING_USER_NAME, type User } from "@overmap-ai/common"

export const getUserDisplayLabel = (user?: Pick<User, "email"> | null) => {
	return user?.email || NON_EXISTING_USER_NAME
}

export const getUserDisplayInitials = (user?: Pick<User, "email"> | null) => {
	return getUserDisplayLabel(user).slice(0, 2).toUpperCase()
}
